import { render, staticRenderFns } from "./program-survey.vue?vue&type=template&id=2226163b&scoped=true"
import script from "./program-survey.vue?vue&type=script&lang=js"
export * from "./program-survey.vue?vue&type=script&lang=js"
import style0 from "./program-survey.vue?vue&type=style&index=0&id=2226163b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226163b",
  null
  
)

export default component.exports